/*
 * Connects the live theme's event layer (assets/tracking.js, window.TBTrack)
 * to this theme. Same calls the live theme made, wired to this theme's markup:
 *   view_item      <- <script type="application/json" data-tb-view-item> on product pages
 *   search         <- <script type="application/json" data-tb-search> on the search page
 *   add_to_cart    <- 'tb:cart-lines-added' event from standard-actions-override.js
 *                     (every add through Shopify.actions.updateCart); names/prices from /cart.js
 *   begin_checkout <- submit of a cart form via its name="checkout" button, using the
 *                     <script type="application/json" data-tb-cart> inside that form
 *   generate_lead  <- submit of any form with an email field named contact[email]
 * Loaded with defer after tracking.js, so TBTrack exists when this runs.
 */
(function (window, document) {
  'use strict';

  function track() {
    return window.TBTrack || null;
  }

  function safe(fn) {
    try { fn(); } catch (e) { /* tracking must never break the UI */ }
  }

  function readJson(root, selector) {
    var el = (root || document).querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }

  function numericId(value) {
    var match = String(value || '').match(/(\d+)\s*$/);
    return match ? match[1] : '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var t = track();
    if (!t) return;
    safe(function () {
      var view = readJson(document, 'script[data-tb-view-item]');
      if (view && view.id) t.trackViewItem(view);
    });
    safe(function () {
      var search = readJson(document, 'script[data-tb-search]');
      if (search && search.terms) t.trackSearch(search.terms);
    });
  });

  document.addEventListener('tb:cart-lines-added', function (event) {
    var t = track();
    var lines = (event.detail && event.detail.lines) || [];
    if (!t || !lines.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byVariant = {};
        (cart.items || []).forEach(function (it) { byVariant[String(it.variant_id)] = it; });
        var items = lines.map(function (line) {
          var id = numericId(line.merchandiseId);
          var it = byVariant[id];
          return {
            id: id,
            name: it ? (it.product_title || it.title) : '',
            price: it ? (it.price || 0) / 100 : 0,
            quantity: line.quantity || 1
          };
        }).filter(function (i) { return i.id; });
        if (items.length) t.trackAddToCart(items);
      })
      .catch(function () {});
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var t = track();
    if (!t) return;

    var submitter = event.submitter;
    if (submitter && submitter.name === 'checkout') {
      safe(function () {
        var cart = readJson(form, 'script[data-tb-cart]');
        if (cart) t.trackBeginCheckoutFromShopifyCart(cart);
      });
      return;
    }

    var email = form.querySelector('input[name="contact[email]"]');
    if (email && email.value) {
      safe(function () { t.trackLead(email.value); });
    }
  }, true);
})(window, document);
